import type { IconSvgElement } from "@hugeicons/react";
import {
  DashboardSquare01Icon, Money03Icon, Building03Icon, PercentSquareIcon, ChartLineData01Icon,
  UserGroupIcon, Settings01Icon,
} from "@hugeicons/core-free-icons";

export interface NavItem {
  title: string;
  path: string;
  icon: IconSvgElement;
  roles: string[];
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

export const SECTIONS: NavSection[] = [
  {
    label: "Main Menu",
    items: [
      { title: "Overview", path: "/", icon: DashboardSquare01Icon, roles: ["admin", "user"] },
      { title: "Clients", path: "/clients", icon: Building03Icon, roles: ["admin", "user"] },
      { title: "Loan Plans", path: "/loan-plans", icon: PercentSquareIcon, roles: ["admin", "user"] },
      { title: "Loans", path: "/loans", icon: Money03Icon, roles: ["admin", "user"] },
      { title: "Revenue", path: "/revenue", icon: ChartLineData01Icon, roles: ["admin", "user"] },
    ],
  },
  {
    label: "Tools",
    items: [
      { title: "Users", path: "/users", icon: UserGroupIcon, roles: ["admin"] },
    ],
  },
];

export const BOTTOM_ITEMS: NavItem[] = [
  { title: "Settings", path: "/settings", icon: Settings01Icon, roles: ["admin", "user"] },
];

export const NAV: NavItem[] = [...SECTIONS.flatMap((sec) => sec.items), ...BOTTOM_ITEMS];

export const isActiveRoute = (path: string, pathname: string) =>
  path === "/" ? pathname === "/" : pathname === path || pathname.startsWith(path + "/");

export const getNavTitle = (pathname: string) =>
  NAV.find((n) => isActiveRoute(n.path, pathname))?.title || "Loan Management";
